import { render, staticRenderFns } from "./Commidity.vue?vue&type=template&id=e20f7dac&scoped=true&"
import script from "./Commidity.vue?vue&type=script&lang=js&"
export * from "./Commidity.vue?vue&type=script&lang=js&"
import style0 from "./Commidity.vue?vue&type=style&index=0&id=e20f7dac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20f7dac",
  null
  
)

export default component.exports